import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useParams, useNavigate } from 'react-router-dom'
import _ from 'lodash'
import { Column } from 'primereact/column'
import RolesService from '../../../services/roles/roles.service'
import HeaderView from '../../../components/common/common-header/HeaderView'
import { rolesPathname } from '../../../routes/settings/pathname'
import DataTableComp from '../../../components/common/data-table/DataTableComp'
import MainCommonView from '../../../components/common/MainCommonView'
import './role.scss'
import CheckboxCom from '../../../components/common/form-components/checkbox/CheckboxComp'

const Role = () => {
  const { formatMessage: msg } = useIntl()
  const navigate = useNavigate()
  const { id } = useParams()

  const [role, setRole] = useState({})

  useEffect(() => {
    getRoleData()
  }, [id])

  const getRoleData = async () => {
    const resp = await RolesService.getById(id)
    if (!resp) {
      navigate(rolesPathname.ROLES)
      return
    }
    setRole(resp.resp)
  }

  const updateRolePermissions = async ({ field, rowIndex }) => {
    const method = field.split('.')[1]
    const updatedRole = JSON.parse(JSON.stringify(role))
    updatedRole.modules[rowIndex].permissions[method] =
      !role.modules[rowIndex].permissions[method]

    const resp = await RolesService.update({ _id: id, body: updatedRole })
    if (resp) {
      setRole(resp?.resp)
    }
  }

  const getValueChecked = (value, rowData) => {
    return (
      <CheckboxCom
        onChange={() => updateRolePermissions(rowData)}
        checked={_.mapValues([value], rowData.field)[0]}
      />
    )
  }

  const dataTable = (
    <DataTableComp
      tableOptions={{
        className: 'role-table',
        value: role?.modules,
        size: 'small',
        groupRowsBy: 'module',
        rowGroupMode: 'rowspan',
        editMode: 'cell',
      }}
      columns={[
        <Column
          field="module"
          style={{ width: '25%' }}
          header={msg({ id: 'module' })}
          body={(rowData) => msg({ id: rowData?.module })}
        />,
        <Column
          field="group"
          style={{ width: '38%' }}
          header={msg({ id: 'group' })}
          body={(rowData) => msg({ id: rowData?.group })}
        />,
        <Column
          field="permissions.post"
          style={{ width: '11%' }}
          body={(options, rowData) => getValueChecked(options, rowData)}
          header={msg({ id: 'create' })}
        />,
        <Column
          field="permissions.patch"
          style={{ width: '11%' }}
          body={(options, rowData) => getValueChecked(options, rowData)}
          header={msg({ id: 'edit' })}
        />,
        <Column
          field="permissions.get"
          style={{ width: '11%' }}
          body={(options, rowData) => getValueChecked(options, rowData)}
          header={msg({ id: 'view' })}
        />,
        <Column
          field="permissions.delete"
          style={{ width: '11%' }}
          body={(options, rowData) => getValueChecked(options, rowData)}
          header={msg({ id: 'delete' })}
        />,
      ]}
    />
  )

  const headerOptions = {
    handlerHeaderActions: {
      showBackButton: true,
    },
  }

  return (
    <div className="role-info-container">
      <HeaderView
        title={msg({ id: 'role' }) + `: ${role?.role}`}
        showBackButton
      />
      <MainCommonView headerOptions={headerOptions} componentData={dataTable} />
    </div>
  )
}

export default Role
